<template>
    <div class="row">
        <ContentOrLoading class="columna-abono-8 tw:lg:pr-4">
            <div v-if="!loading">
                <div class="columna-abono-10" v-if="zona_seleccionada.with_seats && !zona_seleccionada.tiene_plazas">
                    <AsientosComponent
                        :asientos_maximos="200"
                        :abono_seleccionado="abono_seleccionado"
                        :zona="zona_seleccionada"
                        :asientos="datos_de_compradores"
                        :puede_cambiar="true"
                        :dia_abonado="false"
                        :forzar_adyacentes="forzar_adyacentes" 
                        @actualizarDatos="actualizarDatos"
                        ref="asientosComponentRef"
                    />
                </div>
                <div class="col-12" v-else-if="zona_seleccionada.with_seats && zona_seleccionada.tiene_plazas">
                    <LeafletComponent
                        :svgRendered="svgRendered"
                        :plazasSeleccionadas="plazasSeleccionadas"
                        :continuarConCompra="continuarConCompra"
                        :originalColor="originalColor"
                    />
                </div>
                <div class="columna-abono-10" v-else>
                    <div class="col-12">
                        <p>Seleccione el numero de abonos</p>
                        <div class="form-group">
                            <multiselect
                                v-model="n_abonos"
                                placeholder="Seleccionar zona"
                                :show-labels="false"
                                :options="options"
                                :allow-empty="false"
                                @select="actualizarDatos"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-2" v-if="!zona_seleccionada.tiene_plazas"></div>
            </div>
        </ContentOrLoading>
        <div class="columna-abono-4">
            <div class="row">
                <div class="columna-abono-12">
                    <SelectorZonaComponent :zona="zona_seleccionada" :zonas="zonas" @cambiarZona="cambiarZona" :place="recinto"/>
                </div>
                <div class="columna-abono-12">

                    <TusAsientosComponent 
                        :zona="zona_seleccionada"  
                        :asientos="datos_de_compradores" 
                        :butacas="plazasSeleccionadas" 
                        v-on:continuar="continuarCompra" 
                        :configuracion_valida="configuracion_valida" 
                        @bloquearAsientos="bloquearAsientos" 
                        @bloquearAsientosVenta="bloquearAsientosVenta"
                        @eliminar-asiento="eliminarAsiento"
                    />

                </div>
            </div>            
        </div>
        <div class="col-12 mt-3" v-if="zona_seleccionada.tipo_svg == 2">
            <LeyendaColorAnexa />
        </div>
    </div>
</template>

<script>
    import AsientosComponent from '@/components/backend/stepper/components/AsientosComponent';
    import SelectorZonaComponent from '@/components/backend/stepper/components/SelectorZonaComponent';
    import TusAsientosComponent from '@/components/backend/stepper/components/TusAsientosComponent';
    import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
    import { Popover } from 'bootstrap';
    import comprobarButacasLeaflet from '@/mixins/comprobarButacasLeaflet.js';
    import LeyendaColorAnexa from '../../../abonos/bloquear-asientos/LeyendaColorAnexa.vue';

    export default {

        props: ['zona', 'datos_compradores', 'abono_seleccionado', 'zonas', 'session_butaca_data'],

        mixins: [comprobarButacasLeaflet],
        data() {
            return {
                search: '',
                search_for: 'n_abonado',
                loading: false,
                zona_seleccionada: this.zona,
                n_abonos: 0,
                recinto: null,
                configuracion_valida: false,
                forzar_adyacentes: false,
                datos_de_compradores: this.datos_compradores,
                svgRendered: null,
                svg: null,
                continuarConCompra: false,
                plazasSeleccionadas: [],
                plazas: [],
                originalColor: '#0CBA31',
                noDisponibleColor: 'gray',
                seleccionadaColor: '#457ad1',
                vendidaAbonosColor: 'black',
                bloqueadaAbonosColor: '#BF95C4',
                enSesionAbonosColor: 'yellow',
                vendidaEventosColor: 'red',
                bloqueadaEventosColor: 'purple',
                enSesionEventosColor: 'orange',
                abonadoNoRenovado: '#B05D04'
            }
        },
        created() {
            this.setPlace();

            if (this.zona_seleccionada.tiene_plazas) {
                this.getButacas();
                this.configuracion_valida = true;
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            place() {
                return this.$store.getters.getRecinto;
            },
            entradas_disponibles() {
                return this.zona_seleccionada.aforo - this.zona_seleccionada.confirmados - this.zona_seleccionada.no_confirmados;
            },
            options() {
                var tope = 10;

                if(this.entradas_disponibles < tope) {
                    tope = this.entradas_disponibles;
                }

                var opciones = [];

                for(var i = 1; i <= tope; i++) {
                    opciones.push(i);
                }

                return opciones;
            }
        },
        watch: {
            n_abonos() {
                this.datos_de_compradores = [];
                const ab = this.abono_seleccionado;
                for (var i = 0; i < this.n_abonos; i++) {
                    this.datos_de_compradores.push({
                        'apellidos': ab ? ab.surnames : '',
                        'asiento': {
                            'seat': 0,
                            'row': 0,
                            'zona_id': this.zona_seleccionada.id,
                            'tipo_abono_id': ab ? ab.id : null
                        },
                        'cp': ab ? ab.cp : '',
                        'dni': ab ? ab.dni : '',
                        'domicilio': ab ? ab.domicilio : '',
                        'email': ab ? ab.email : '',
                        'empresa': ab ? ab.empresa : '',
                        'es_nuevo': false,
                        'fecha_nacimiento': ab ? ab.fecha_nacimiento : '',
                        'genero_id': ab ? ab.genero_id : '',
                        'localidad': ab ? ab.localidad : '',
                        'n_abonado_antiguo': ab ? ab.n_abonado_antiguo : '',
                        'nombre': ab ? ab.name : '',
                        'observaciones': ab ? ab.observaciones : '',
                        'pais': ab ? ab.pais : '',
                        'penista': ab ? ab.penista : '',
                        'plaza': ab && ab.plaza ? { ...ab.plaza } : {},
                        'precio': null,
                        'precios': this.zona_seleccionada.precios,
                        'provincia': ab ? ab.provincia : '',
                        'telefono': ab ? ab.telefono : '',
                        'url_imprimir': ''
                    });
                }
            },
            zona_seleccionada() {
                if (this.zona_seleccionada.tiene_plazas) {
                    this.getButacas();
                }
            }
        },
        methods: {
            setPlace() {
                if(this.abono_seleccionado && this.abono_seleccionado.place) {
                    this.recinto = this.abono_seleccionado.place;
                } else {
                    this.recinto = this.place;
                }
            },
            goTo(paso) {
                this.$emit('goTo', paso, this.datos_de_compradores);
            },
            actualizarDatos(datos, configuracion_valida) {
                this.datos_de_compradores = datos;

                if(this.manager.tipo != 1) {
                    this.configuracion_valida = configuracion_valida;
                }

                if(!this.forzar_adyacentes) {
                    this.configuracion_valida = true;
                }
            },
            cambiarZona(new_zona) {
                this.$emit('resetDatos', new_zona);
                this.n_abonos = 0;
                this.zona_seleccionada = new_zona;
                this.plazasSeleccionadas = [];
                this.datos_de_compradores = this.datos_compradores;
            },
            bloquearAsientos(paso) {
                this.loading = true;

                var seats = [];
                var plazas = [];

                for (var i in this.datos_de_compradores) {
                    if (this.zona_seleccionada.with_seats) {
                        if (this.datos_de_compradores[i].asiento && (this.datos_de_compradores[i].asiento.asiento >= 0 && !this.datos_de_compradores[i].plaza)) {
                            seats.push({
                                seat: this.datos_de_compradores[i].asiento.asiento,
                                row: this.datos_de_compradores[i].asiento.fila,
                                zona_id: this.datos_de_compradores[i].asiento.zona_id,
                                tipo_abono_id: this.abono_seleccionado ? this.abono_seleccionado.id : null,
                                lfp_id: this.datos_de_compradores[i].asiento.lfp_id ? this.datos_de_compradores[i].asiento.lfp_id : null,
                            });
                        } else if (this.datos_de_compradores[i].plaza) {
                            plazas.push({
                                id: this.datos_de_compradores[i].plaza.id,
                                region_id: this.zona_seleccionada.id
                            });
                        }
                    } else {
                        seats.push({
                            seat: 0,
                            row: 0,
                            zona_id: this.datos_de_compradores[i].asiento.zona_id,
                            tipo_abono_id: this.abono_seleccionado ? this.abono_seleccionado.id : null,
                            lfp_id: this.datos_de_compradores[i].asiento.lfp_id ? this.datos_de_compradores[i].asiento.lfp_id : null,
                        });
                    }
                }

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    zona_id: this.zona_seleccionada.id,
                    asientos: seats,
                    butacas: plazas,
                    tid: this.configuracion.hash_teatro,
                    taquilla: 1
                }

                this.$store.dispatch(this.config.getVuexAlias('front.bloquear.asientos'), params).then(res => {
                    if(res.data.error) {
                        this.volver();
                        this.$toast.error(res.data.message);
                    } else {
                        this.$emit('setSessionId', res.data.session_id);
                        this.$emit('setSessionButacaData', res.data.sesiones);

                        this.loading = false;
                        this.goTo(paso);
                    }

                }).catch(error => {
                    this.$toast.error('Butaca ya escogida o no hay stock');
                    console.log(error);
                    this.loading = false;
                });
            },
            bloquearAsientosVenta(concepto, etiqueta, butacas) {
                this.loading = true;

                var seats = [];
                var plazas = [];

                for (var i in butacas) {
                    if (butacas[i].asiento && butacas[i].asiento.asiento) {
                        seats.push({
                            seat: butacas[i].asiento.asiento,
                            row: butacas[i].asiento.fila,
                            region_id: butacas[i].asiento.zona_id,
                            tipo_abono_id: this.abono_seleccionado ? this.abono_seleccionado.id : null,
                            lfp_id: butacas[i].asiento.lfp_id ? butacas[i].asiento.lfp_id : null,
                        });
                    } else {
                        plazas = butacas.map(butaca => butaca.id);
                    }
                }

                const params = {
                    filters: {},
                    lista_id: this.$store.getters.getListaId,
                    recinto_id: this.$store.getters.getRecinto.id,
                    asientos: seats,
                    butacas: plazas,
                    zona_id: this.zona_seleccionada?.id
                };

                if (concepto) {
                    params.concepto = concepto;
                }

                if(etiqueta){
                    params.etiqueta_bloqueo_id = etiqueta.id
                }

                this.$store.dispatch(this.config.getVuexAlias(seats.length > 0 ? 'back.abonos.bloquear.asientos' : 'back.abonos.bloquear.butacas'), params).then(res => {
                    this.$emit('resetDatos', this.zona_seleccionada)
                    this.loading = false;
                    this.getButacas();
                });
            },
            getButacas() {
                this.loading = true;

                const params = {
                    filters: {},
                    lista_id: this.$store.getters.getListaId,
                    recinto_id: this.place.id,
                    region_id: this.zona_seleccionada.id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.abonos.listado-butacas-region'), params).then(res => {
                    this.plazas = res.data.data;
                    this.setPlazasConf(this.plazas);
                    this.getSvg();
                }).catch(() => {
                    console.error('Error al recuperar las butacas en la venta de abonos en taquilla');
                });
            },
            getSvg() {
                const params = {
                    filters: {},
                    recinto_id: this.place.id,
                    region_id: this.zona.id,
                }

                this.$store.dispatch(this.config.getVuexAlias('recinto.zona-svg'), params).then(res => {
                    this.svg = res.data.svg;
                    this.renderLeafletSvg(this.svg);
                    this.loading = false;
                }).catch(error => {
                    console.log(error);
                    console.warn('Error al recupera el svg de la región anexa en la venta de abonos en taquilla');
                });
            },
            renderLeafletSvg(svg) {
                const butacasFiltered = this.plazas.filter(butaca => butaca.svg_id);

                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = svg;

                const svgElement = tempDiv.firstElementChild;
                const butacas = svgElement.querySelectorAll('[id^="butaca"]');

                butacas.forEach(circle => {
                    circle.setAttribute('seleccionado', 'false');
                    circle.setAttribute('opacity', '0.8');
                    const svg_id = this.getButacaId(circle);
                    const butaca = butacasFiltered.find(butaca => butaca.svg_id == svg_id);

                    if (butaca) {
                        const title = this.getButacaName(butaca);

                        if (butaca.libre && butaca.precios.length > 0) {
                            const content = '<strong>DISPONIBLE</strong>' + this.getAbonadoInfoHtml(butaca);
                            this.drawPopover(circle, content, title);

                            circle.style.cursor = 'pointer';
                            circle.style.transition = 'fill 0.2s'
                            circle.setAttribute('fill', this.originalColor);
                            butaca.originalColor = this.originalColor;

                            circle.addEventListener('click', () => {
                                let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));

                                setTimeout(() => {
                                    if (!this.isPanning) {
                                        if (!isSeleccionado) {
                                            circle.setAttribute('fill', this.seleccionadaColor);
                                            circle.setAttribute('seleccionado', 'true');
                                        } else {
                                            circle.setAttribute('fill', this.originalColor);
                                            circle.setAttribute('seleccionado', 'false');
                                        }
                                        this.clickButaca(butaca);
                                    }
                                }, 150);
                            });
                        } else if (!butaca.disponible && butaca.precios.length > 0) {
                            if (butaca.ocupada.venta) {
                                this.drawPopover(circle, '<strong>VENDIDA</strong>' + this.getAbonadoInfoHtml(butaca), title);
                                circle.setAttribute('ocupada', 'true');
                                circle.setAttribute('fill', this.vendidaAbonosColor)
                                butaca.originalColor = this.vendidaAbonosColor;
                                // Permitir seleccionar la butaca propia al renovar
                                if (this.abono_seleccionado && butaca.info_ocupada?.id_abonado === this.abono_seleccionado.id) {
                                    circle.style.cursor = 'pointer';
                                    circle.addEventListener('click', () => {
                                        let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));
                                        setTimeout(() => {
                                            if (!isSeleccionado) {
                                                circle.setAttribute('fill', this.seleccionadaColor);
                                                circle.setAttribute('seleccionado', 'true');
                                            } else {
                                                circle.setAttribute('fill', this.vendidaAbonosColor);
                                                circle.setAttribute('seleccionado', 'false');
                                            }
                                            this.clickButaca(butaca);
                                        }, 150);
                                    });
                                }
                            } else if (butaca.ocupada.evento_venta) {
                                this.drawPopover(circle, '<strong>VENDIDA (EVENTOS)</strong>' + this.getAbonadoInfoHtml(butaca), title);
                                circle.setAttribute('ocupada', 'true');
                                circle.setAttribute('fill', this.vendidaEventosColor)
                                butaca.originalColor = this.vendidaEventosColor;
                            } else if (butaca.ocupada.bloqueada) {
                                let bloqueadaContent = '<div><strong>BLOQUEADA</strong></div>';
                                if (butaca.etiqueta_bloqueo?.name) {
                                    bloqueadaContent += '<div><strong>' + butaca.etiqueta_bloqueo.name + '</strong></div>';
                                }
                                if (butaca.info_ocupada?.concepto) {
                                    bloqueadaContent += '<div><strong>Concepto: </strong>' + butaca.info_ocupada.concepto + '</div>';
                                }
                                bloqueadaContent += this.getAbonadoInfoHtml(butaca);
                                this.drawPopover(circle, bloqueadaContent, title);
                                circle.setAttribute('ocupada', 'true');
                                const bloqueadaColor = butaca.etiqueta_bloqueo?.color || this.bloqueadaAbonosColor;
                                circle.setAttribute('fill', bloqueadaColor);
                                butaca.originalColor = bloqueadaColor;

                                if (!this.abono_seleccionado) {
                                    if (this.checkDisponibilidad(butaca)) {
                                        butaca.libre = true;
                                        butaca.disponible = true;
                                    }

                                    circle.addEventListener('click', () => {
                                        let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));

                                        setTimeout(() => {
                                            if (!this.isPanning) {
                                                if (!isSeleccionado) {
                                                    circle.setAttribute('fill', this.seleccionadaColor);
                                                    circle.setAttribute('seleccionado', 'true');
                                                } else {
                                                    circle.setAttribute('fill', bloqueadaColor);
                                                    circle.setAttribute('seleccionado', 'false');
                                                }
                                                this.clickButaca(butaca);
                                            }
                                        }, 150);
                                    });
                                }
                            } else if (butaca.ocupada.evento_bloqueo) {
                                this.drawPopover(circle, '<strong>BLOQUEADA (EVENTOS)</strong>' + this.getAbonadoInfoHtml(butaca), title);
                                circle.setAttribute('ocupada', 'true');
                                circle.setAttribute('fill', this.bloqueadaEventosColor);
                                butaca.originalColor = this.bloqueadaEventosColor;
                            } else if (butaca.ocupada.sesion) {
                                this.drawPopover(circle, '<strong>EN SESIÓN</strong>' + this.getAbonadoInfoHtml(butaca), title);
                                circle.setAttribute('ocupada', 'true');
                                circle.setAttribute('fill', this.enSesionAbonosColor)
                                butaca.originalColor = this.enSesionAbonosColor;
                            } else if (butaca.ocupada.evento_sesion) {
                                this.drawPopover(circle, '<strong>EN SESIÓN (EVENTOS)</strong>' + this.getAbonadoInfoHtml(butaca), title);
                                circle.setAttribute('ocupada', 'true');
                                circle.setAttribute('fill', this.enSesionEventosColor)
                                butaca.originalColor = this.enSesionEventosColor;
                            }
                        } else {
                            this.drawPopover(circle, '<strong>NO DISPONIBLE</strong>' + this.getAbonadoInfoHtml(butaca), title);
                            circle.setAttribute('no-disponible', 'true');
                            circle.setAttribute('fill', this.noDisponibleColor)
                            butaca.originalColor = this.noDisponibleColor;
                        }
                    }
                });

                this.svgRendered = tempDiv.firstElementChild;
            },
            getButacaId(circle) {
                const id = circle.id;
                const idParts = id.split("-");

                return idParts[1];
            },
            getButacaName(butaca) {
                const nButaca = butaca.butaca;
                const nFila = butaca.fila;
                const sector = butaca.sector_name;
                const visibilidad_reducida = butaca.visibilidad_reducida;
                const porcentaje_visibilidad = butaca.porcentaje_visibilidad;
                let name = '';

                if (sector) {
                    name += `Sector: ${sector} - `;
                }

                if (!nButaca && !nFila) {
                    name += `Plaza: ${butaca.numero}`;
                } else {
                    name += `Fila: ${nFila} - Butaca: ${nButaca}`;
                }

                if (visibilidad_reducida) {
                    name += '<span class="text-danger"> Visibilidad Reducida</span>';
                }

                if (porcentaje_visibilidad) {
                    name += `<span class="text-danger">: ${porcentaje_visibilidad} %</span>`;
                }

                return name;
            },
            getAbonadoInfoHtml(butaca) {
                const info = butaca.info_ocupada;
                if (!info || (!info.nombre && !info.apellido && !info.numero_abonado)) {
                    return '';
                }
                let html = '';
                if (info.nombre || info.apellido) {
                    html += '<div><strong>' + [info.nombre, info.apellido].filter(Boolean).join(' ') + '</strong></div>';
                }
                if (info.numero_abonado) {
                    html += '<div><strong>Nº Abonado: ' + info.numero_abonado + '</strong></div>';
                }
                return html;
            },
            drawPopover(circle, content, title = null) {
                const popoverOptions = {
                    html: true,
                    title: title,
                    content: '<div style="text-align:left">' + content + '</div>',
                    trigger: 'hover',
                    container: 'body'
                }

                return new Popover(circle, popoverOptions);
            },
            clickButaca(plazaSeleccionada) {
                const plazaEncontrada = this.plazas.find(plaza => plaza.id == plazaSeleccionada.id);
                if (plazaEncontrada) {
                    plazaEncontrada.seleccionada = !plazaEncontrada.seleccionada;
                    plazaEncontrada.plazaName = this.getButacaName(plazaSeleccionada);

                    if (plazaEncontrada.seleccionada) {
                        if (!this.plazasSeleccionadas.some(plaza => plaza.id === plazaSeleccionada.id)) {
                            this.plazasSeleccionadas.push(plazaSeleccionada);
                            this.plazasSeleccionadas.sort((a, b) => a.butaca - b.butaca);
                        }
                    } else {
                        const index = this.plazasSeleccionadas.findIndex(plaza => plaza.id === plazaSeleccionada.id);
                        if (index !== -1) {
                            this.plazasSeleccionadas.splice(index, 1);
                        }
                    }
                }
            },
            continuarCompra() {
                if (this.datos_de_compradores && this.datos_de_compradores.length > 0) {
                    this.bloquearAsientos(3);
                } else if (this.plazasSeleccionadas.length > 0) {
                    let datos_compradores = [];

                    this.plazasSeleccionadas.forEach(butaca => {
                        let descuentos = [];

                        butaca.precios.forEach(tipo_abono => {
                            descuentos = descuentos.concat(tipo_abono.descuentos);
                        });

                        const plazaConPrecios = { ...butaca };
                        const butacaTieneDescuentos = butaca.precios && butaca.precios.some(p => p.descuentos && p.descuentos.length > 0);
                        if (!butacaTieneDescuentos && this.abono_seleccionado && this.abono_seleccionado.plaza && this.abono_seleccionado.plaza.precios) {
                            plazaConPrecios.precios = this.abono_seleccionado.plaza.precios;
                        }

                        datos_compradores.push({
                            'apellidos': this.abono_seleccionado ? this.abono_seleccionado.surnames : '',
                            'dni': this.abono_seleccionado ? this.abono_seleccionado.dni : '',
                            'es_nuevo': this.abono_seleccionado ? false : true,
                            'nombre': this.abono_seleccionado ? this.abono_seleccionado.name : '',
                            'precio': null,
                            'precios': descuentos,
                            'tipos_abonos': butaca.precios,
                            'telefono': this.abono_seleccionado ? this.abono_seleccionado.telefono : '',
                            'url_imprimir': '',
                            'plaza': plazaConPrecios,
                            'n_abonado_antiguo': this.abono_seleccionado ? this.abono_seleccionado.n_abonado_antiguo : '',
                            'email': this.abono_seleccionado ? this.abono_seleccionado.email : '',
                            'domicilio': this.abono_seleccionado ? this.abono_seleccionado.domicilio : '',
                            'cp': this.abono_seleccionado ? this.abono_seleccionado.cp : '',
                            'pais': this.abono_seleccionado ? this.abono_seleccionado.pais : '',
                            'provincia': this.abono_seleccionado ? this.abono_seleccionado.provincia : '',
                            'localidad': this.abono_seleccionado ? this.abono_seleccionado.localidad : '',
                            'fecha_nacimiento': this.abono_seleccionado ? this.abono_seleccionado.fecha_nacimiento : '',
                            'genero_id': this.abono_seleccionado ? this.abono_seleccionado.genero_id : '',
                            'penista': this.abono_seleccionado ? this.abono_seleccionado.penista : '',
                            'empresa': this.abono_seleccionado ? this.abono_seleccionado.empresa : '',
                            'observaciones': this.abono_seleccionado ? this.abono_seleccionado.observaciones : ''
                        });
                    });

                    this.datos_de_compradores = datos_compradores;
                    this.bloquearAsientos(3);
                }
            },
            checkDisponibilidad(butaca) {
                var disponible = butaca.libre || butaca.disponible;

                if (!disponible && butaca.ocupada) {
                    if (butaca.ocupada.bloqueada && (!butaca.ocupada.venta && !butaca.ocupada.sesion && !butaca.ocupada.evento_venta && !butaca.ocupada.evento_sesion && !butaca.ocupada.renovado && !butaca.ocupada.evento_bloqueo)) {
                        disponible = true;
                    }
                }

                return disponible;
            },
            eliminarAsiento(asiento) {
                if(this.$refs.asientosComponentRef) {
                    this.$refs.asientosComponentRef.toggleSeleccion(asiento.fila, asiento.asiento, true, true);
                }
            }
        },
        components: {
            AsientosComponent, SelectorZonaComponent, TusAsientosComponent, LeafletComponent, LeyendaColorAnexa
        }
    }
</script>

<style scoped>
    .columna-abono-8 {
        -ms-flex: 0 0 66.666667%;
        flex: 0 0 66.666667%;
        max-width: 66.666667%;
    }

    .columna-abono-4 {
        -ms-flex: 0 0 33.333333%;
        flex: 0 0 33.333333%;
        max-width: 33.333333%;
    }

    .columna-abono-10 {
        -ms-flex: 0 0 83.333333%;
        flex: 0 0 83.333333%;
        max-width: 83.333333%;
        }


    @media (max-width: 768px) {
        .columna-abono-8 {
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            max-width: 100%;
        }

        .columna-abono-4 {
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            max-width: 100%;
            padding: 50px;
        }

        .columna-abono-10 {
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            max-width: 100%;
            padding: 50px;
            padding-right: 7.5px;
            padding-left: 7.5px;
        }

        .columna-abono-12 {
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            max-width: 100%;
            width: 100%;
            position: relative;
            padding-right: -7.5px;
            padding-left: -7.5px;
        }

        .row {
            padding: 7,5px;
        }
    }
</style>